import React from 'react';
import cn from 'classnames';

import { RepeatOnSwitchContainer } from './styled';

const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

interface RepeatOnSwitchProps {
  value: string;
  onChange: (day: string) => void;
  disabled: boolean;
}

const RepeatOnSwitch = ({ value, onChange, disabled }: RepeatOnSwitchProps) => {
  const onDayClick = (day: string) => () => onChange(day);

  return (
    <RepeatOnSwitchContainer $disabled={disabled}>
      {days.map(day => (
        <div
          className={cn('day', value === day && 'selected')}
          onClick={!disabled ? onDayClick(day) : undefined}
          key={day}
        >
          {day[0]}
        </div>
      ))}
    </RepeatOnSwitchContainer>
  );
};

export default RepeatOnSwitch;
